export default "__VITE_ASSET__Bp5bHXmj__"